/**
 * @generated SignedSource<<3cf85521bab329b0dbcfc5e7383f09bd>>
 * @relayHash e60aa4bbe3e8e564d5efcbac06a88233
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7dd60613781bda67c40bd5c06e6073d1bf578b724b948b3ce74e2e9f3303be1d

import type { ConcreteRequest } from 'relay-runtime';
export type preloadContentSmartLinksQuery$variables = {
  contentId: string;
};
export type preloadContentSmartLinksQuery$data = {
  readonly contentSmartLinks: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly canView: boolean;
      readonly emojiTitle: string | null | undefined;
      readonly iconUrl: string | null | undefined;
      readonly product: string | null | undefined;
      readonly resolved: boolean;
      readonly resourceType: string | null | undefined;
      readonly subType: string | null | undefined;
      readonly title: string | null | undefined;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type preloadContentSmartLinksQuery = {
  response: preloadContentSmartLinksQuery$data;
  variables: preloadContentSmartLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedSmartLinkList",
    "kind": "LinkedField",
    "name": "contentSmartLinks",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "emojiTitle"
          },
          {
            "kind": "ScalarField",
            "name": "canView"
          },
          {
            "kind": "ScalarField",
            "name": "product"
          },
          {
            "kind": "ScalarField",
            "name": "resourceType"
          },
          {
            "kind": "ScalarField",
            "name": "subType"
          },
          {
            "kind": "ScalarField",
            "name": "iconUrl"
          },
          {
            "kind": "ScalarField",
            "name": "resolved"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e60aa4bbe3e8e564d5efcbac06a88233",
    "id": "7dd60613781bda67c40bd5c06e6073d1bf578b724b948b3ce74e2e9f3303be1d",
    "metadata": {},
    "name": "preloadContentSmartLinksQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksQuery($contentId:ID!){contentSmartLinks(id:$contentId){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}}}"
  }
};
})();

(node as any).hash = "45952b76e4b10a1d4c45176a81952be2";

export default node;
